/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines a utlity to return Device Symbol based on the CIMSymbol feature
 * 
 *   import {createDeviceSymbol} from '@ion/dls/src/maps/symbols/DeviceSymbol';
 * 
 *   const renderer = {
 *     type : 'CIMPointSymbol',
 *     symbolLayers: [
 *       createDeviceSymbol()
 *     ]
 *    };
 */
export const createDeviceSymbol = (size: number = 3.5, color: number[] = [51, 51, 51]) => {
  return {
    type               : 'CIMVectorMarker',
    enable             : true,
    anchorPointUnits   : 'Relative',
    dominantSizeAxis3D : 'Y',
    size,
    billboardMode3D    : 'FaceNearPlane',
    frame              : {xmin: 0, ymin: 0, xmax: 28, ymax: 17},
    markerGraphics     : [
      {
        type     : 'CIMMarkerGraphic',
        geometry : {
          rings : [
            [
              [0, 17],
              [28, 17],
              [28, 0],
              [0, 0],
              [0, 17]
            ]
          ]
        },
        symbol : {
          type         : 'CIMPolygonSymbol',
          symbolLayers : [
            {
              type        : 'CIMSolidStroke',
              enable      : true,
              capStyle    : 'Round',
              joinStyle   : 'Round',
              lineStyle3D : 'Strip',
              miterLimit  : 10,
              width       : 0,
              color       : [0, 0, 0, 255]
            },
            {
              type   : 'CIMSolidFill',
              enable : true,
              color  : [...color, 255]
            }
          ]
        }
      }
    ],
    scaleSymbolsProportionally : true,
    respectFrame               : true,
    colorLocked                : true,
    offsetY                    : 0,
    offsetX                    : -2
  };
};
